{
  "#KUNDEN_KONDITIONSLISTE": {
    "APP": "Artikelinformationen",
    "TITLE": "Kunden Konditionsliste",
    "LIST": {
      "TITLE": "Konditionsblatt",
      "VALID_FROM": "Gültig Ab",
      "VALID_UNTIL": "Gültig Bis",
      "NEW_PRICE_DATE": "Neues Preisdatum",
      "DATE": "Datum",
      "SAVE": "Speichern",
      "ARTICLE": "Artikel",
      "UNIT": "Einheit",
      "CLIENT_SALE_PRICE": "Kunden VK-Preis",
      "CLIENT_SALE_NEW_PRICE": "Neuer VK-Preis",
      "NOTE_LINE": "Zeilenvermerk",
      "NOTE": "Vermerk",
      "PRICE_PER_UNIT": "Preis / Einheit",
      "GROSS_PRICE_INFO": "Alle Preise verstehen sich als Bruttopreise"
    },
    "MESSAGES": {
      "PRINT": {
        "SUCCESS": {
          "TITLE": "Datei wurde erfolgreich heruntergeladen"
        }
      },
      "SUCCESS": {
        "TITLE": "Erfolg",
        "MESSAGE": "Die Operation war erfolgreich!"
      },
      "ERROR": {
        "TITLE": "Fehler",
        "MESSAGE": "Es ist ein unerwarteter Fehler aufgetreten!"
      }
    }
  }
}
